import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { ErpObject } from './types';

export const evaluateErpNumber = (entity: Entities, data: ErpObject) => {
  return entity === Entities.contract ? data?.contractNumber : data?.number;
};
